const questions = [
  "avalon",
  "bugs",
  "fight",
  "boba",
  "movie",
  "book",
  "soju",
  "la gour",
  "cemetary",
  "reservoir",
  "pierce",
  "story",
  "book",
];

export default questions;

